// extracted by mini-css-extract-plugin
export default {"register":"Register_register__G8Uf7","inputRegister":"Register_inputRegister__f-qF7","password":"Register_password__JtUvw","btnSubmit":"Register_btnSubmit__sLIwn"};